import React from "react";
import { Redirect } from "react-router-dom";
import Markdown from "markdown-to-jsx";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";

import logo from "../../assets/logo.png";
import termsText from "./termsText";
import termsEnabled from "./termsEnabled";

// Página pública (sem login): o checkbox do cadastro aponta para cá.
const useStyles = makeStyles((theme) => ({
	page: {
		minHeight: "100vh",
		backgroundColor: theme.palette.background.default,
		padding: theme.spacing(4, 2),
	},
	logo: {
		display: "block",
		width: 220,
		maxWidth: "70%",
		margin: "0 auto 24px",
	},
	paper: {
		padding: theme.spacing(4),
		color: theme.palette.text.primary,
		lineHeight: 1.6,
		[theme.breakpoints.down("xs")]: {
			padding: theme.spacing(2),
		},
		"& h1": {
			fontSize: "1.6rem",
			margin: "0 0 16px",
		},
		"& h2": {
			fontSize: "1.15rem",
			margin: "28px 0 8px",
		},
		"& p, & li": {
			fontSize: "0.95rem",
		},
		"& table": {
			width: "100%",
			borderCollapse: "collapse",
			fontSize: "0.9rem",
		},
		"& th, & td": {
			border: `1px solid ${theme.palette.divider}`,
			padding: 8,
			textAlign: "left",
			verticalAlign: "top",
		},
	},
}));

const Terms = () => {
	const classes = useStyles();

	// Site sem Termos (REACT_APP_SHOW_TERMS desligado): a página não existe.
	if (!termsEnabled) return <Redirect to="/login" />;

	return (
		<div className={classes.page}>
			<Container maxWidth="md">
				<img className={classes.logo} src={logo} alt={process.env.REACT_APP_NAME || ""} />
				<Paper className={classes.paper}>
					<Markdown>{termsText}</Markdown>
				</Paper>
			</Container>
		</div>
	);
};

export default Terms;
